import { Text } from '@leroy-merlin-br/backyard-react-ui'

import { Icon } from './components/Icon'
import * as S from './styled'

const StampLeroyWarrant = () => (
  <S.Wrapper>
    <div>
      <Icon />
    </div>

    <S.Content>
      <Text size="kilo" noMargin bold>
        Leroy Merlin Garante
      </Text>

      <Text size="kilo" noMargin>
        Garantimos a venda e entrega pela nossa loja parceira.{' '}
        <a target="_blank" rel="noopener" href="/leroy-merlin-garante">
          Saiba mais
        </a>
        .
      </Text>
    </S.Content>
  </S.Wrapper>
)

export default StampLeroyWarrant
